import React from 'react';

import { ServiceCard } from './ServiceCard';

import { servicesPage } from '../../../data';

import "../../../css/components/services/services-page.scss";
export function ServicesPage() {
  window.scrollTo(0,0);
  const serviceCards = servicesPage.services.map((service, index) => {
    return (
      <ServiceCard key={ index } service={ service } />
    )
  })

  const headerText = servicesPage.headerText.map((text, index) => {
    return (
      <p key={ index }>
        { text }
      </p>
    )
  });

  return (
    <div className="services-page">
      <div className="page-header">
        <div className="header page-header--std">
          { servicesPage.header }
        </div>
        <div className="header-text">
          { headerText }
        </div>
      </div>
      <div className="service-cards">
        { serviceCards }
      </div>
    </div>
  )
}